import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { EnumGender } from '../../../model/enum-gender';

@JsonObject('KovanHrPerPersonnelSearchModel')
export class PerPersonnelSearchModel {
    @EmptyControl()
    @JsonProperty('hrmPerPeopleId', Number, true)
    hrmPerPeopleId: number = null;

    @EmptyControl()
    @JsonProperty('hrmPerPeopleUuid', String, true)
    hrmPerPeopleUuid: string = null;

    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @EmptyControl()
    @JsonProperty('registryNumber', String, true)
    registryNumber: string = null;

    @EmptyControl()
    @JsonProperty('pictureUuid', String, true)
    pictureUuid: string = null;

    pictureSource: string;

    @EmptyControl()
    @JsonProperty('orgHrmPerObjectDefId', Number, true)
    orgHrmPerObjectDefId: number = null;

    @EmptyControl()
    @JsonProperty('orgHrmPerObjectDefText', String, true)
    orgHrmPerObjectDefText: string = null;

    @JsonProperty('posHrmPerObjectDefId', Number, true)
    posHrmPerObjectDefId: number = null;

    @EmptyControl()
    @JsonProperty('posHrmPerObjectDefText', String, true)
    posHrmPerObjectDefText: string = null;

    @EmptyControl()
    @JsonProperty('personSummaryPrefix', String, true)
    personSummaryPrefix: string = null;

    @EmptyControl()
    @JsonProperty('personSummarySuffix', String, true)
    personSummarySuffix: string = null;

    @EmptyControl()
    @JsonProperty('identificationNumber', String, true)
    identificationNumber: string = null;

    @EmptyControl()
    @JsonProperty('secondment', Boolean, true)
    secondment: boolean = null;

    @EmptyControl()
    @JsonProperty('hrmPerEmployeeTypeId', Number, true)
    hrmPerEmployeeTypeId: number = null;

    @EmptyControl()
    @JsonProperty('hrmPerEmployeeSubtypeId', Number, true)
    hrmPerEmployeeSubtypeId: number = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;

    @EmptyControl()
    @JsonProperty('gender', String, true)
    gender: EnumGender = null;

    get fullName() {
        return `${this.name} ${this.surname}`;
    }

    get fullNameWithRegistry() {
        return `${this.fullName} (${this.registryNumber ? this.registryNumber.toString() : '-'})`;
    }

    get personSummaryText() {
        return (this.personSummaryPrefix ?? '') + this.fullNameWithRegistry + (this.personSummarySuffix ?? '');
    }
}
